import React from 'react'
import { Col, Row } from 'react-bootstrap'
import RecentInvoices from '../../components/dashboard/recentInvoices'
import SelfUtilisation from '../../components/dashboard/selfUtilisation'
import MissingTimesheets from '../../components/dashboard/missingTimesheets'
import HoursByClient from '../../components/dashboard/hoursByClient'
import { AppContext } from '../../App'
import { TestingStaff } from './dashboardWrapper'

interface CadetInterSeniorDashboardProps {
	testingStaff?: TestingStaff
}

const CadetInterSeniorDashboard = (props: CadetInterSeniorDashboardProps) => {
	const { appState } = React.useContext(AppContext)

	return (
		<>
			<Row className="pt-4">
				<Col sm={4}>
					<SelfUtilisation period="week" testingStaff={props.testingStaff} />
				</Col>
				<Col sm={4}>
					<SelfUtilisation period="month" testingStaff={props.testingStaff} />
				</Col>
				<Col sm={4}>
					<SelfUtilisation period="year" testingStaff={props.testingStaff} />
				</Col>
			</Row>
			<Row className="py-4">
				<Col sm={4}>
					<Row>
						<Col>
							<MissingTimesheets period="week" testingStaff={props.testingStaff} />
						</Col>
					</Row>
					<Row className="pt-4">
						<Col>
							<HoursByClient period="week" testingStaff={props.testingStaff} />
						</Col>
					</Row>
				</Col>
				<Col sm={8}>
					<RecentInvoices
						onlySelfRaised
						replaceDueDateWithStatus
						viewingUserID={props.testingStaff?.id || appState.authState.attributes?.['custom:userId'] || ''}
					/>
				</Col>
			</Row>
		</>
	)
}

export default CadetInterSeniorDashboard
